const Templates = {
  templates: [
    {
      id: 2,
      name: "Basic version",
      description:
        "A widget that shows information of the players with global stats and info about the current match",
      image: "./templates/basic-version.png",
    },
    {
      id: 1,
      name: "Extended version",
      description:
        'Extend the "Basic version" with more info: Top Civs, Top Maps and Winrate by duration',
      image: "./templates/extended-version.png",
    },
  ],
};

export default Templates;
